export const categories = [
  "dressing",
  "dining",
  "chair",
  "sofa",
  "bed",
  "wardrobe",
];
export const brands = [
  "IKEA",
  "Ashley Furniture Industries",
  "West Elm",
  "Restoration Hardware (RH)",
  "Crate & Barrel",
  "Herman Miller",
  "La-Z-Boy",
  "Ethan Allen",
  "Williams-Sonoma Home",
  "Pottery Barn",
];
export const ratings = [4.5, 4, 3, 2, 1];
export const materials = ["Wood", "Fabric", "Metal", "Plastic"];
export const color = [
  "#808080",
  "#FFFFFF",
  "#000000",
  "#F5F5DC",
  "#DEB887",
  "#654321",
  "#000080",
  "#50C878",
];
export const locations = [
  "Mumbai",
  "Delhi",
  "Bangalore",
  "Kolkata",
  "Chennai",
  "Hyderabad",
  "Pune",
  "Ahmedabad",
  "Jaipur",
  "Chandigarh",
  "Surat",
  "Lucknow",
  "Kochi",
  "Indore",
  "Nagpur",
  "Patna",
  "Visakhapatnam",
  "Vadodara",
  "Bhopal",
  "Coimbatore",
];

export const sortOptionsData = [
  { value: "priceHighToLow", label: "Price: High to Low" },
  { value: "priceLowToHigh", label: "Price: Low to High" },
  { value: "ratingHighToLow", label: "Rating: High to Low" },
  { value: "ratingLowToHigh", label: "Rating: Low to High" },
  { value: "alphabeticalAZ", label: "Alphabetical(A-Z)" },
  { value: "alphabeticalZA", label: " Alphabetical(Z-A)" },
];

export const priceRanges = [
  { id: "2", range: "$50 - $100", min: 50, max: 100 },
  { id: "3", range: "$100 - $200", min: 101, max: 200 },
  { id: "4", range: "$200 - $300", min: 201, max: 300 },
  { id: "5", range: "$300 - $400", min: 301, max: 400 },
  { id: "6", range: "$400 - $500", min: 401, max: 500 },
  { id: "7", range: "$500 - $600", min: 501, max: 600 },
  { id: "8", range: "$600 - $700", min: 601, max: 700 },
  { id: "9", range: "$700 - $800", min: 701, max: 800 },
  { id: "10", range: "$800 - $900", min: 801, max: 900 },
  { id: "11", range: "$900 - $1000", min: 901, max: 1000 },
  { id: "12", range: "$1000 and above", min: 1001, max: Infinity },
];

